"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7826],{

/***/ 17826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Login; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-firebase-hooks/auth/dist/index.esm.js
var dist_index_esm = __webpack_require__(3349);
// EXTERNAL MODULE: ./services/firebase/index.ts + 2 modules
var firebase = __webpack_require__(35780);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/brand/LogoIcon.tsx
var LogoIcon = __webpack_require__(58952);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/index.esm.js
var auth_dist_index_esm = __webpack_require__(16690);
// EXTERNAL MODULE: ./utils/dates.ts
var dates = __webpack_require__(47744);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./hooks/usePaymentsData.ts
var usePaymentsData = __webpack_require__(40819);
// EXTERNAL MODULE: ./node_modules/@mui/joy/Button/Button.js + 3 modules
var Button = __webpack_require__(91977);
// EXTERNAL MODULE: ./node_modules/@mui/joy/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(86436);
// EXTERNAL MODULE: ./node_modules/@mui/joy/Typography/Typography.js + 2 modules
var Typography = __webpack_require__(25977);
// EXTERNAL MODULE: ./node_modules/@mui/joy/Sheet/Sheet.js + 2 modules
var Sheet = __webpack_require__(51883);
;// CONCATENATED MODULE: ./hooks/useBrowserType.ts

function useBrowserType() {
  var _useState = (0,react.useState)(false),
      isEmbeddedBrowser = _useState[0],
      setIsEmbeddedBrowser = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      userAgent = _useState2[0],
      setUserAgent = _useState2[1];

  (0,react.useEffect)(function () {
    var _navigator;

    if ((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.userAgent) {
      setIsEmbeddedBrowser(!!(navigator.userAgent.includes('AppName') || navigator.userAgent.includes('Instagram')));
      setUserAgent(navigator.userAgent);
    }
  }, []);
  return {
    isEmbeddedBrowser: isEmbeddedBrowser,
    userAgent: userAgent
  };
}
// EXTERNAL MODULE: ./services/firebase/functions.ts
var functions = __webpack_require__(29890);
// EXTERNAL MODULE: ./node_modules/@mui/joy/Input/Input.js + 5 modules
var Input = __webpack_require__(69392);
// EXTERNAL MODULE: ./services/stripe/index.ts
var stripe = __webpack_require__(94921);
// EXTERNAL MODULE: ./node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(2031);
// EXTERNAL MODULE: ./hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(40689);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Login.tsx




var _excluded = ["title", "subtitle", "defaultSigningUp", "postLogoElement", "blockRedirect", "customSuccessMessage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




























var Separator = function Separator() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex opacity-50 items-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-white w-full h-px mx-2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "or"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-white  w-full h-px mx-2"
    })]
  });
};

function Login(_ref) {
  var _router$query, _router$query2;

  var title = _ref.title,
      subtitle = _ref.subtitle,
      defaultSigningUp = _ref.defaultSigningUp,
      postLogoElement = _ref.postLogoElement,
      blockRedirect = _ref.blockRedirect,
      customSuccessMessage = _ref.customSuccessMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var router = (0,next_router.useRouter)();
  var annualBilling = ((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.billing) === "annual"; // @ts-ignore

  var forcePlan = (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.plan;

  var _useSignInWithGoogle = (0,dist_index_esm/* useSignInWithGoogle */.Kp)(firebase/* auth */.I8),
      _useSignInWithGoogle2 = (0,slicedToArray/* default */.Z)(_useSignInWithGoogle, 4),
      signInWithGoogle = _useSignInWithGoogle2[0],
      googleUser = _useSignInWithGoogle2[1],
      googleLoading = _useSignInWithGoogle2[2],
      googleError = _useSignInWithGoogle2[3];

  var _useSignInWithTwitter = (0,dist_index_esm/* useSignInWithTwitter */.ku)(firebase/* auth */.I8),
      _useSignInWithTwitter2 = (0,slicedToArray/* default */.Z)(_useSignInWithTwitter, 4),
      signInWithTwitter = _useSignInWithTwitter2[0],
      twitterUser = _useSignInWithTwitter2[1],
      twitterLoading = _useSignInWithTwitter2[2],
      twitterError = _useSignInWithTwitter2[3]; // todo: make validation work


  var _useForm = (0,react_hook_form_dist_index_esm/* useForm */.cI)(),
      register = _useForm.register,
      formState = _useForm.formState,
      handleSubmit = _useForm.handleSubmit;

  var _useSignInWithEmailAn = (0,dist_index_esm/* useSignInWithEmailAndPassword */.Cp)(firebase/* auth */.I8),
      _useSignInWithEmailAn2 = (0,slicedToArray/* default */.Z)(_useSignInWithEmailAn, 4),
      signInWithEmailAndPassword = _useSignInWithEmailAn2[0],
      emailUser = _useSignInWithEmailAn2[1],
      emailLoading = _useSignInWithEmailAn2[2],
      error = _useSignInWithEmailAn2[3];

  var _usePaymentsData = (0,usePaymentsData/* usePaymentsData */.E)(),
      startCheckoutSession = _usePaymentsData.startCheckoutSession,
      basicPrice = _usePaymentsData.basicPrice,
      loadingCheckout = _usePaymentsData.loadingCheckout,
      annualPrice = _usePaymentsData.annualPrice,
      appsumoPrice = _usePaymentsData.appsumoPrice;

  var _useState = (0,react.useState)(defaultSigningUp || false),
      signingUp = _useState[0],
      setSigningUp = _useState[1];

  (0,react.useEffect)(function () {
    setSigningUp(defaultSigningUp || false);
  }, [defaultSigningUp]);

  var _useState2 = (0,react.useState)(false),
      customLoading = _useState2[0],
      setCustomLoading = _useState2[1];

  var loading = emailLoading || googleLoading || twitterLoading || customLoading || loadingCheckout;
  var stripePromoCode = router.query.promo_code;
  var usdPricing19Enabled = (0,esm/* useFeatureIsOn */.cC)("19usd_mo_pricing");

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      logEvent = _useAnalytics.logEvent;

  var signInAndRedirect = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(fn, method) {
      var _userCredentials$user, _userCredentials$user2;

      var userCredentials, _auth$currentUser, localStorageReferral, referral, _auth$currentUser2;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fn();

            case 2:
              userCredentials = _context.sent;

              if (userCredentials) {
                _context.next = 6;
                break;
              }

              dist/* default.error */.ZP.error("Couldn't sign in with the chosen method... Please reload and try again");
              return _context.abrupt("return");

            case 6:
              if (!((_userCredentials$user = userCredentials.user) !== null && _userCredentials$user !== void 0 && (_userCredentials$user2 = _userCredentials$user.metadata) !== null && _userCredentials$user2 !== void 0 && _userCredentials$user2.creationTime && (0,dates/* dateIsLessThanSecondsAgo */.hL)(new Date(userCredentials.user.metadata.creationTime), 20))) {
                _context.next = 41;
                break;
              }

              // user just signed up
              logEvent("sign_up", {
                method: method,
                user_id: (_auth$currentUser = firebase/* auth.currentUser */.I8.currentUser) === null || _auth$currentUser === void 0 ? void 0 : _auth$currentUser.uid
              }); // claim referral

              localStorageReferral = localStorage.getItem("referral");
              referral = router.query.referral || localStorageReferral;

              if (!(referral && referral !== "subscribe")) {
                _context.next = 19;
                break;
              }

              _context.prev = 11;
              _context.next = 14;
              return (0,functions/* redeemReferralCode */.Qj)({
                referralCode: referral
              });

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](11);
              console.error(_context.t0);

            case 19:
              if (!(forcePlan === "basic")) {
                _context.next = 32;
                break;
              }

              if (!annualBilling) {
                _context.next = 27;
                break;
              }

              _context.next = 23;
              return startCheckoutSession(usdPricing19Enabled ? stripe/* ANNUAL_PRICE_ID_19USD */.h2 : stripe/* ANNUAL_PRICE_ID */.$L);

            case 23:
              dist/* default.loading */.ZP.loading("Redirecting to Stripe...");
              return _context.abrupt("return");

            case 27:
              _context.next = 29;
              return startCheckoutSession(usdPricing19Enabled ? stripe/* MONTHLY_PRICE_ID_19USD */.Ut : stripe/* MONTHLY_PRICE_ID */.$Q);

            case 29:
              dist/* default.loading */.ZP.loading("Redirecting to Stripe...");

            case 30:
              _context.next = 39;
              break;

            case 32:
              if (!(forcePlan === "appsumotwitvid")) {
                _context.next = 38;
                break;
              }

              dist/* default.loading */.ZP.loading("Redirecting to Stripe...");
              _context.next = 36;
              return startCheckoutSession((appsumoPrice === null || appsumoPrice === void 0 ? void 0 : appsumoPrice.id) || usePaymentsData/* STRIPE_APPSUMO_PRICE_ID */.K, true);

            case 36:
              _context.next = 39;
              break;

            case 38:
              if (!blockRedirect) {
                window.location.assign("/videos/create?signedUp=true"); // basicPrice?.id && (await startCheckoutSession(basicPrice?.id))
              }

            case 39:
              _context.next = 43;
              break;

            case 41:
              logEvent("sign_in", {
                method: method,
                user_id: (_auth$currentUser2 = firebase/* auth.currentUser */.I8.currentUser) === null || _auth$currentUser2 === void 0 ? void 0 : _auth$currentUser2.uid
              });

              if (!blockRedirect) {
                router.push("/videos/create");
              }

            case 43:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[11, 16]]);
    }));

    return function signInAndRedirect(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var signInEmail = function signInEmail() {
    handleSubmit( /*#__PURE__*/function () {
      var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
        var email, password, userCred;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                email = _ref3.email, password = _ref3.password;
                setCustomLoading(true);
                _context2.prev = 2;
                _context2.next = 5;
                return signInWithEmailAndPassword(email, password);

              case 5:
                userCred = _context2.sent;

                if (userCred) {
                  _context2.next = 8;
                  break;
                }

                throw new Error("Couldn't sign in with the given credentials... Please reload or try a different password");

              case 8:
                if (userCred !== null && userCred !== void 0 && userCred.user) {
                  if (!blockRedirect) {
                    router.push("/videos/create");
                  }
                }

                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);
                console.log(_context2.t0);
                (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.toString) && dist/* default.error */.ZP.error(_context2.t0.toString());

              case 15:
                setCustomLoading(false);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 11]]);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }())();
  };

  var signUpEmail = function signUpEmail() {
    handleSubmit( /*#__PURE__*/function () {
      var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref5) {
        var email, password, _auth$currentUser3, localStorageReferral, referral;

        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                email = _ref5.email, password = _ref5.password;
                setCustomLoading(true);
                _context3.prev = 2;
                _context3.next = 5;
                return dist/* default.promise */.ZP.promise((0,auth_dist_index_esm/* createUserWithEmailAndPassword */.Xb)(firebase/* auth */.I8, email, password), {
                  loading: "Creating account...",
                  success: customSuccessMessage || "Welcome to Twitvid!",
                  error: "Please reload the page and try again"
                });

              case 5:
                logEvent("sign_up", {
                  method: "email",
                  user_id: (_auth$currentUser3 = firebase/* auth.currentUser */.I8.currentUser) === null || _auth$currentUser3 === void 0 ? void 0 : _auth$currentUser3.uid
                }); // claim referral

                localStorageReferral = localStorage.getItem("referral");
                referral = router.query.referral || localStorageReferral;

                if (!referral) {
                  _context3.next = 17;
                  break;
                }

                _context3.prev = 9;
                _context3.next = 12;
                return (0,functions/* redeemReferralCode */.Qj)({
                  referralCode: referral
                });

              case 12:
                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](9);
                console.error("Couldn't redeem referral code ".concat(referral));

              case 17:
                if (!(forcePlan === "basic")) {
                  _context3.next = 30;
                  break;
                }

                if (!annualBilling) {
                  _context3.next = 25;
                  break;
                }

                dist/* default.loading */.ZP.loading("Redirecting to Stripe...");
                _context3.next = 22;
                return startCheckoutSession(usdPricing19Enabled ? stripe/* ANNUAL_PRICE_ID_19USD */.h2 : stripe/* ANNUAL_PRICE_ID */.$L);

              case 22:
                return _context3.abrupt("return");

              case 25:
                dist/* default.loading */.ZP.loading("Redirecting to Stripe...");
                _context3.next = 28;
                return startCheckoutSession(usdPricing19Enabled ? stripe/* MONTHLY_PRICE_ID_19USD */.Ut : stripe/* MONTHLY_PRICE_ID */.$Q);

              case 28:
                _context3.next = 37;
                break;

              case 30:
                if (!(forcePlan === "appsumotwitvid")) {
                  _context3.next = 36;
                  break;
                }

                dist/* default.loading */.ZP.loading("Redirecting to Stripe...");
                _context3.next = 34;
                return startCheckoutSession((appsumoPrice === null || appsumoPrice === void 0 ? void 0 : appsumoPrice.id) || usePaymentsData/* STRIPE_APPSUMO_PRICE_ID */.K, true);

              case 34:
                _context3.next = 37;
                break;

              case 36:
                if (!blockRedirect) {
                  // router.push(`/videos/create?signedUp=true`)
                  window.location.assign("/videos/create?signedUp=true"); // if (basicPrice.id) {
                  //     await startCheckoutSession(basicPrice.id)
                  // }
                  // toast.loading("Redirecting to payment form...")
                }

              case 37:
                _context3.next = 43;
                break;

              case 39:
                _context3.prev = 39;
                _context3.t1 = _context3["catch"](2);
                console.error("Error signing up with email: ".concat(_context3.t1));

                if (_context3.t1.code === "auth/email-already-in-use") {
                  dist/* default.error */.ZP.error("Email already in use");
                } else {
                  (_context3.t1 === null || _context3.t1 === void 0 ? void 0 : _context3.t1.toString) && dist/* default.error */.ZP.error("Something went wrong... Please reload try again");
                }

              case 43:
                setCustomLoading(false);

              case 44:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 39], [9, 14]]);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }())();
  };

  var _useBrowserType = useBrowserType(),
      isEmbeddedBrowser = _useBrowserType.isEmbeddedBrowser;

  var _useState3 = (0,react.useState)(false),
      redeemingCode = _useState3[0],
      setRedeemingCode = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      referralCode = _useState4[0],
      setReferralCode = _useState4[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col items-center justify-center text-white w-full md:w-96 p-4 md:p-0",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center mb-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoIcon/* default */.Z, {
        className: " fill-white"
      }), postLogoElement]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col justify-center align-center w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-white font-semibold text-3xl mb-3 text-center",
        children: stripePromoCode && Object.values(stripe/* PROMO_CODES */.Q2).includes(stripePromoCode) ? "Redeem your special offer!" : redeemingCode ? "Redeem code" : title || (signingUp ? "Welcome!" : "Log in to your account")
      }), !redeemingCode && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: "text-center text-white mb-8",
          children: [subtitle || (stripe/* PROMO_CODES.smma3months */.Q2.smma3months === stripePromoCode ? "Sign in or sign up to get 3 months free" : stripe/* PROMO_CODES.smma1month */.Q2.smma1month === stripePromoCode ? "Sign in or sign up to get 1 month free" : signingUp ? "Create an account to continue" : "Welcome back! Please login to continue."), !stripePromoCode && !signingUp && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "opacity-70  text-sm m-auto -mb-4 mt-1 cursor-pointer hover:underline ",
            onClick: function onClick() {
              return setRedeemingCode(true);
            },
            children: "Redeem a promo code"
          })]
        })
      })]
    }), redeemingCode ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Sheet/* default */.Z, {
      sx: {
        maxWidth: 450,
        width: "100%",
        mx: "auto",
        // margin left & right
        // px: 2, // padding left & right
        display: "flex",
        flexDirection: "column",
        gap: 2,
        borderRadius: "sm",
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        color: "white"
      },
      variant: "outlined",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.ZP, {
        placeholder: "Enter your referral code",
        value: referralCode,
        onChange: function onChange(e) {
          return setReferralCode(e.target.value);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        sx: {
          mt: 1
          /* margin top */
          ,
          backgroundColor: "transparent !important",
          color: "white"
        },
        loading: loading,
        variant: "outlined",
        onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
          return regenerator_default().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  router.push("/invite/".concat(referralCode, "?appsumo=true"));

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })),
        disabled: !referralCode,
        children: "Redeem"
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Sheet/* default */.Z, {
      sx: {
        maxWidth: 450,
        width: "100%",
        mx: "auto",
        // margin left & right
        // px: 2, // padding left & right
        display: "flex",
        flexDirection: "column",
        gap: 2,
        borderRadius: "sm",
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        color: "white"
      },
      variant: "outlined",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z // html input attribute
      , _objectSpread(_objectSpread({
        type: "email",
        error: !!formState.errors.email || !!error,
        helperText: error ? "Wrong email or password" : "",
        placeholder: "johndoe@email.com",
        className: ""
      }, register("email", {
        required: true,
        pattern: /^\S+@\S+$/i
      })), {}, {
        label: "Email",
        sx: {
          label: {
            color: "white"
          },
          helperText: {
            color: "white"
          }
        }
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, _objectSpread(_objectSpread({
        error: !!formState.errors.password || !!error,
        type: "password",
        placeholder: "\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF",
        autoComplete: "password",
        label: "Password"
      }, register("password", {
        required: true
      })), {}, {
        sx: {
          label: {
            color: "white"
          }
        }
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        sx: {
          mt: 1
          /* margin top */
          ,
          backgroundColor: "white",
          color: "black"
        },
        loading: loading,
        variant: "outlined",
        disabled: !formState.isValid,
        className: "bg-transparent  disabled:opacity-50 border cursor-pointer hover:bg-transparent border-white text-white  bg-opacity-95 font-semibold text-base ",
        onClick: function onClick() {
          return signingUp ? signUpEmail() : signInEmail();
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-black text-base",
          children: signingUp ? "Sign up" : "Log in"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col w-full space-y-4 text-gray-900",
        children: [!isEmbeddedBrowser && /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          onClick: function onClick() {
            return signInAndRedirect(signInWithGoogle, "google");
          },
          className: "hover:bg-gray-300 transition-colors duration-500 bg-blue-50 text-gray-900 font-semibold border border-gray-300 flex flex-row items-center justify-center rounded-lg py-2 gap-x-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaGoogle */.ldW, {}), "Continue with Google"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          onClick: function onClick() {
            return signInAndRedirect(signInWithTwitter, "twitter");
          },
          className: "hover:bg-gray-300 transition-colors duration-500 bg-blue-50 text-gray-900 font-semibold border border-gray-200 flex flex-row items-center justify-center rounded-lg py-2 gap-x-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {}), "Continue with Twitter"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.C, {
        endDecorator: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-white cursor-pointer  font-semibold",
          onClick: function onClick() {
            return setSigningUp(!signingUp);
          },
          children: signingUp ? "Log in" : "Sign up"
        }),
        fontSize: "sm",
        sx: {
          alignSelf: "center"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-white opacity-70",
          children: signingUp ? "Already got an account?" : "Don't have an account?"
        })
      })]
    })]
  });
}

/***/ }),

/***/ 58952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["color", "width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var LogoIcon = function LogoIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#FFFFFF" : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 50 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 40 : _ref$height,
      rest = (0,_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", _objectSpread(_objectSpread({}, rest), {}, {
    width: width,
    height: height,
    viewBox: "0 0 50 40",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M0 23.4429C0 22.6511 0.641947 22.0091 1.43383 22.0091H32.2987C33.0906 22.0091 33.7325 22.6511 33.7325 23.4429C33.7325 32.2416 26.5998 39.3744 17.8011 39.3744H15.9314C7.13274 39.3744 0 32.2416 0 23.4429Z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M47.5776 8.74688C48.6493 9.36008 48.6493 10.9056 47.5776 11.5188L35.773 18.2728C34.7085 18.8819 33.3832 18.1133 33.3832 16.8868L33.3832 3.3789C33.3832 2.15245 34.7085 1.38385 35.773 1.99291L47.5776 8.74688Z"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (LogoIcon);

/***/ }),

/***/ 40689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useAnalytics; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _firebase_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _services_firebase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35780);
/* harmony import */ var _splitbee_web__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23848);






function useAnalytics() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      analytics = _useState[0],
      setAnalytics = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    ;

    (0,_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var analytics;
      return _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_services_firebase__WEBPACK_IMPORTED_MODULE_3__/* .getFirebaseAnalytics */ .M6)();

            case 2:
              analytics = _context.sent;
              setAnalytics(analytics);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);

  var _logEvent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(eventName, params) {
      return _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _splitbee_web__WEBPACK_IMPORTED_MODULE_4__/* ["default"].track */ .Z.track(eventName, params);

              if (!analytics) {
                _context2.next = 4;
                break;
              }

              console.log("[analytics] logging event: ", eventName, params);
              return _context2.abrupt("return", (0,_firebase_analytics__WEBPACK_IMPORTED_MODULE_1__/* .logEvent */ .Kz)(analytics, eventName, params || {}));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [analytics, _splitbee_web__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z]);

  return {
    analytics: analytics,
    logEvent: _logEvent
  };
}

/***/ }),

/***/ 40819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ usePaymentsData; },
/* harmony export */   "K": function() { return /* binding */ STRIPE_APPSUMO_PRICE_ID; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _stripe_firestore_stripe_payments__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64338);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _services_firebase_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29890);
/* harmony import */ var _services_stripe__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94921);
/* harmony import */ var _useUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14917);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86501);
/* harmony import */ var _services_firebase__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35780);
/* harmony import */ var _useAnalytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40689);









 // price_1MTtbtGOGhxZLaYPjdmMJVbS => 4.99/mo price
// price_1MV4qBGOGhxZLaYPE7kpRuvM => 7.99/mo price

var STRIPE_APPSUMO_PRICE_ID = "price_1MV4RuGOGhxZLaYPPbGTdIX7";
function usePaymentsData() {
  var _useUser = (0,_useUser__WEBPACK_IMPORTED_MODULE_5__/* .useUser */ .a)(),
      user = _useUser.user;

  var _useAnalytics = (0,_useAnalytics__WEBPACK_IMPORTED_MODULE_8__/* .useAnalytics */ .z)(),
      logEvent = _useAnalytics.logEvent; // for now: only product here will be the premium plan with only one price (monthly)


  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      stripeProductsByPlan = _useState[0],
      setStripeProductsByPlan = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(undefined),
      currentUserSubscription = _useState2[0],
      setCurrentUserSubscription = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    ;

    (0,_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var products, productsByPlan;
      return _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!user || stripeProductsByPlan["basic"])) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return (0,_stripe_firestore_stripe_payments__WEBPACK_IMPORTED_MODULE_1__/* .getProducts */ .Xp)(_services_stripe__WEBPACK_IMPORTED_MODULE_4__/* .paymentsInstance */ ._z, {
                includePrices: true,
                activeOnly: true
              });

            case 4:
              products = _context.sent;
              productsByPlan = products.reduce(function (acc, p) {
                p.role && (acc[p.role] = p);
                return acc;
              }, {});
              setStripeProductsByPlan(productsByPlan);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))() // load subscription
    ;

    (0,_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var subscription;
      return _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!user || currentUserSubscription !== undefined || currentUserSubscription)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return (0,_stripe_firestore_stripe_payments__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentUserSubscriptions */ .aO)(_services_stripe__WEBPACK_IMPORTED_MODULE_4__/* .paymentsInstance */ ._z, {
                status: "active"
              });

            case 5:
              subscription = _context2.sent;
              setCurrentUserSubscription((subscription === null || subscription === void 0 ? void 0 : subscription.length) > 0 ? subscription[0] : null);
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              console.error("error while retrieving current user subscription : ".concat(_context2.t0));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 9]]);
    }))();
  }, [user]);

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loadingCheckout = _useState3[0],
      setLoadingCheckout = _useState3[1];
  /**
   * Redirect to a stripe checkout session for a given plan.
   * @param planPriceId
   * @param payment if true, will redirect to the payment page instead of the subscription page
   */


  var startCheckoutSession = /*#__PURE__*/function () {
    var _ref3 = (0,_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(planPriceId, payment) {
      var redirect,
          promoCode,
          analytics,
          price,
          planName,
          sessionParams,
          session,
          _args3 = arguments;
      return _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              redirect = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
              promoCode = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : null;
              console.log("starting checkout session for plan: ", planPriceId, " for user:", user === null || user === void 0 ? void 0 : user.uid);
              setLoadingCheckout(true);
              _context3.next = 6;
              return (0,_services_firebase__WEBPACK_IMPORTED_MODULE_7__/* .getFirebaseAnalytics */ .M6)();

            case 6:
              analytics = _context3.sent;
              // find corresponding price across all products
              price = Object.values(stripeProductsByPlan).reduce(function (acc, p) {
                var price = p.prices.find(function (pr) {
                  return pr.id === planPriceId;
                });

                if (price) {
                  acc = price;
                }

                return acc;
              }, null); // find plan name

              planName = Object.keys(stripeProductsByPlan).find(function (k) {
                return stripeProductsByPlan[k].role === (price === null || price === void 0 ? void 0 : price.role);
              }); // if (!user) throw new Error("User is not logged in")

              if (planPriceId) {
                _context3.next = 11;
                break;
              }

              throw new Error("No plan price id provided");

            case 11:
              if (!loadingCheckout) {
                _context3.next = 14;
                break;
              }

              console.log("already loading checkout");
              return _context3.abrupt("return");

            case 14:
              _context3.prev = 14;
              sessionParams = {
                price: planPriceId,
                success_url: "".concat(window.location.origin, "/videos/create?purchased=true"),
                mode: payment ? "payment" : "subscription",
                // allow promo codes
                allow_promotion_codes: true
              };

              if (promoCode && promoCode.startsWith("promo_")) {
                sessionParams["promotion_code"] = promoCode;
              } else if (window.localStorage.getItem("promoCode")) {
                sessionParams["promotion_code"] = window.localStorage.getItem("promoCode");
              }

              _context3.next = 19;
              return (0,_stripe_firestore_stripe_payments__WEBPACK_IMPORTED_MODULE_1__/* .createCheckoutSession */ .Mc)(_services_stripe__WEBPACK_IMPORTED_MODULE_4__/* .paymentsInstance */ ._z, sessionParams);

            case 19:
              session = _context3.sent;

              if (!redirect) {
                _context3.next = 25;
                break;
              }

              logEvent("begin_checkout", {
                plan: planName,
                currency: (price === null || price === void 0 ? void 0 : price.currency) || "usd",
                // todo: CHANGE IF PLAN CHANGES
                value: 0,
                items: price !== null && price !== void 0 && price.id ? [{
                  item_id: price === null || price === void 0 ? void 0 : price.id,
                  item_name: planName
                }] : undefined
              });
              window.location.assign(session.url);
              _context3.next = 27;
              break;

            case 25:
              console.log("session url:", session.url);
              return _context3.abrupt("return", session.url);

            case 27:
              _context3.next = 33;
              break;

            case 29:
              _context3.prev = 29;
              _context3.t0 = _context3["catch"](14);
              react_hot_toast__WEBPACK_IMPORTED_MODULE_6__/* ["default"].error */ .ZP.error("Couldn't start checkout session... Please reload and try again.");
              console.error(_context3.t0);

            case 33:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[14, 29]]);
    }));

    return function startCheckoutSession(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loadingDashboard = _useState4[0],
      setLoadingDashboard = _useState4[1];

  var redirectToStripeDashboard = /*#__PURE__*/function () {
    var _ref4 = (0,_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
      var _yield$createPortalLi, data;

      return _vercel_path0_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setLoadingDashboard(true);
              _context4.next = 3;
              return (0,_services_firebase_functions__WEBPACK_IMPORTED_MODULE_3__/* .createPortalLink */ .AG)({
                returnUrl: window.location.origin,
                locale: "auto" // Optional, defaults to "auto"

              });

            case 3:
              _yield$createPortalLi = _context4.sent;
              data = _yield$createPortalLi.data;
              setLoadingDashboard(false); // @ts-ignore

              window.location.assign(data.url);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function redirectToStripeDashboard() {
      return _ref4.apply(this, arguments);
    };
  }();

  var basicPrice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    var _stripeProductsByPlan;

    return (_stripeProductsByPlan = stripeProductsByPlan["basic"]) === null || _stripeProductsByPlan === void 0 ? void 0 : _stripeProductsByPlan.prices.find(function (p) {
      return p.active && p.id === _services_stripe__WEBPACK_IMPORTED_MODULE_4__/* .MONTHLY_PRICE_ID */ .$Q;
    });
  }, [stripeProductsByPlan]);
  var annualPrice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)( // price_1MV4SnGOGhxZLaYPtJGVNW9o => annual 76.70/y price
  function () {
    var _stripeProductsByPlan2;

    return (_stripeProductsByPlan2 = stripeProductsByPlan["basic"]) === null || _stripeProductsByPlan2 === void 0 ? void 0 : _stripeProductsByPlan2.prices.find(function (p) {
      return p.active && p.id === _services_stripe__WEBPACK_IMPORTED_MODULE_4__/* .ANNUAL_PRICE_ID */ .$L;
    });
  }, [stripeProductsByPlan]);
  var premiumPrice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    var _stripeProductsByPlan3;

    return (_stripeProductsByPlan3 = stripeProductsByPlan["premium"]) === null || _stripeProductsByPlan3 === void 0 ? void 0 : _stripeProductsByPlan3.prices.find(function (p) {
      return p.active;
    });
  }, [stripeProductsByPlan]);
  var appsumoPrice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)( // price_1MV4RuGOGhxZLaYPPbGTdIX7 => annual 76.70/y price
  function () {
    var _stripeProductsByPlan4;

    return (_stripeProductsByPlan4 = stripeProductsByPlan["basic"]) === null || _stripeProductsByPlan4 === void 0 ? void 0 : _stripeProductsByPlan4.prices.find(function (p) {
      return p.active && p.id === STRIPE_APPSUMO_PRICE_ID;
    });
  }, [stripeProductsByPlan]);
  return {
    redirectToStripeDashboard: redirectToStripeDashboard,
    loadingDashboard: loadingDashboard,
    startCheckoutSession: startCheckoutSession,
    loadingCheckout: loadingCheckout,
    premiumPlanProduct: stripeProductsByPlan["premium"],
    // todo: rename to business, or unlimited plan
    basicPlanProduct: stripeProductsByPlan["basic"],
    premiumPrice: premiumPrice,
    annualPrice: annualPrice,
    basicPrice: basicPrice,
    appsumoPrice: appsumoPrice,
    currentUserSubscription: currentUserSubscription
  };
}

/***/ }),

/***/ 29890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$E": function() { return /* binding */ createTwitterVideo; },
/* harmony export */   "AG": function() { return /* binding */ createPortalLink; },
/* harmony export */   "Aj": function() { return /* binding */ redeemInviteCode; },
/* harmony export */   "Fy": function() { return /* binding */ searchStockFootage; },
/* harmony export */   "NG": function() { return /* binding */ refreshTiktokToken; },
/* harmony export */   "NQ": function() { return /* binding */ getSuggestedFootageForTweet; },
/* harmony export */   "Qd": function() { return /* binding */ createApiKey; },
/* harmony export */   "Qj": function() { return /* binding */ redeemReferralCode; },
/* harmony export */   "Z3": function() { return /* binding */ getTweet; },
/* harmony export */   "iU": function() { return /* binding */ logTestEvent; },
/* harmony export */   "pM": function() { return /* binding */ getTiktokUser; },
/* harmony export */   "qA": function() { return /* binding */ getLatestUserTweets; },
/* harmony export */   "vD": function() { return /* binding */ onPaymentCreatedManual; },
/* harmony export */   "z2": function() { return /* binding */ searchTwitterUsers; },
/* harmony export */   "zf": function() { return /* binding */ refreshTiktokAccessToken; }
/* harmony export */ });
/* unused harmony exports createVideoThumbManually, createTestVideos, sendDailyStatsTest */
/* harmony import */ var firebase_functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26146);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35780);


// connectFunctionsEmulator(functions, "localhost", 5001)
var createVideoThumbManually = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "createVideoThumbManually");
var createTwitterVideo = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "createTwitterVideo");
var createPortalLink = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "ext-firestore-stripe-payments-createPortalLink");
var createTestVideos = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "createTestVideos");
var getTweet = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "getTweet");
var getSuggestedFootageForTweet = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "getSuggestedFootageForTweet");
var searchStockFootage = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "searchPexels");
var redeemInviteCode = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "redeemInviteCode");
var redeemReferralCode = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "redeemReferralCode");
var sendDailyStatsTest = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "sendDailyStatsTest");
var onPaymentCreatedManual = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "onPaymentCreatedManual");
var createApiKey = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "createApiKey");
var searchTwitterUsers = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "searchTwitterUsers");
var getLatestUserTweets = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "getLatestUserTweets");
var getTiktokUser = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "getTiktokUser"); // refreshes tiktok refresh token using the auth code. updates user.integrations.tiktok doc

var refreshTiktokToken = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "refreshTiktokToken");
var refreshTiktokAccessToken = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "refreshTiktokAccessToken");
var logTestEvent = (0,firebase_functions__WEBPACK_IMPORTED_MODULE_0__/* .httpsCallable */ .V1)(_index__WEBPACK_IMPORTED_MODULE_1__/* .functions */ .wk, "logTestEvent");

/***/ }),

/***/ 94921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ ANNUAL_PRICE_ID; },
/* harmony export */   "$Q": function() { return /* binding */ MONTHLY_PRICE_ID; },
/* harmony export */   "Q2": function() { return /* binding */ PROMO_CODES; },
/* harmony export */   "Ut": function() { return /* binding */ MONTHLY_PRICE_ID_19USD; },
/* harmony export */   "_z": function() { return /* binding */ paymentsInstance; },
/* harmony export */   "eJ": function() { return /* binding */ APPSUMO_PRICE_ID; },
/* harmony export */   "h2": function() { return /* binding */ ANNUAL_PRICE_ID_19USD; }
/* harmony export */ });
/* harmony import */ var _stripe_firestore_stripe_payments__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64338);
/* harmony import */ var _firebase_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35780);


var paymentsInstance = (0,_stripe_firestore_stripe_payments__WEBPACK_IMPORTED_MODULE_0__/* .getStripePayments */ .pX)(_firebase_index__WEBPACK_IMPORTED_MODULE_1__/* .app */ .l2, {
  productsCollection: "products",
  customersCollection: "users"
});
var APPSUMO_PRICE_ID = "price_1MV231GOGhxZLaYPbr6oks4f";
var ANNUAL_PRICE_ID = "price_1MV4SnGOGhxZLaYPtJGVNW9o";
var MONTHLY_PRICE_ID = "price_1MV4qBGOGhxZLaYPE7kpRuvM";
var MONTHLY_PRICE_ID_19USD = "price_1Mrh8AGOGhxZLaYPv32dsIav";
var ANNUAL_PRICE_ID_19USD = "price_1Mrh7hGOGhxZLaYPt9l9Q72s";
var PROMO_CODES = {
  smma3months: "promo_1MrJDNGOGhxZLaYPD7YgHqLy",
  smma1month: "promo_1MrmAsGOGhxZLaYPWjASBVNb",
  email3months30percent: "promo_1Mo8J0GOGhxZLaYPZWq1S9XW"
};

/***/ }),

/***/ 47744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T8": function() { return /* binding */ prettyDate; },
/* harmony export */   "hL": function() { return /* binding */ dateIsLessThanSecondsAgo; }
/* harmony export */ });
/* unused harmony exports dateToMonth, dateToMonthYear */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);


function join(t, a, s) {
  function format(m) {
    var f = new Intl.DateTimeFormat("en", m);
    return f.format(t);
  }

  return a.map(format).join(s);
}

var a = [{
  day: "numeric"
}, {
  month: "short"
}, {
  year: "numeric"
}];
function prettyDate(d) {
  var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var delta = Math.round((+new Date() - d) / 1000);
  var minute = 60,
      hour = minute * 60,
      day = hour * 24,
      week = day * 7;
  var fuzzy;

  if (delta < 30) {
    fuzzy = "just now";
  } else if (delta < 2 * minute) {
    fuzzy = "a minute ago";
  } else if (delta < 20 * minute) {
    fuzzy = Math.floor(delta / minute) + " minutes ago";
  } else if (delta < hour) {
    fuzzy = Math.floor(delta / (10 * minute)) * 10 + " minutes ago";
  } else if (Math.floor(delta / hour) == 1) {
    fuzzy = "1 hour ago";
  } else if (delta < day) {
    fuzzy = Math.floor(delta / hour) + " hours ago";
  } else if (delta < day * 2) {
    fuzzy = "yesterday";
  } else if (delta < week) {
    fuzzy = Math.floor(delta / day) + " days ago";
  } else {
    if (includeTime) {
      fuzzy = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(d).format("DD MMM HH:mm");
    } else {
      fuzzy = join(d, a, " ");
    }
  }

  return fuzzy;
}
var monthNames = (/* unused pure expression or super */ null && (["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]));
var monthNamesShort = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
var dateToMonth = function dateToMonth(d) {
  return monthNamesShort[d.getMonth()];
};
var dateToMonthYear = function dateToMonthYear(d) {
  return "".concat(dateToMonth(d), " ").concat(d.getFullYear());
};
var dateIsLessThanSecondsAgo = function dateIsLessThanSecondsAgo(d, seconds) {
  return (new Date().getTime() - d.getTime()) / 1000 < seconds;
};

/***/ })

}]);